// Logo popup  
document.addEventListener('DOMContentLoaded', function () {
  // Open popup
  document.querySelectorAll('.logoBx').forEach((logo) => {
    logo.addEventListener('click', function () {
      const popup = this.querySelector('.openPop');

      if (popup) {
        popup.style.display = 'block';
      }
    });
  });

  // Close popup on close button click
  document.querySelectorAll('.openIt').forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();

      const popup = this.closest('.openPop');

      if (popup) {
        popup.style.display = 'none';
      }
    });
  });

  // Close all popups when page is scrolled
  window.addEventListener('scroll', function () {
    document.querySelectorAll('.openPop').forEach((popup) => {
      popup.style.display = 'none';
    });
  });
});
// Logo popup END





document.addEventListener("DOMContentLoaded", function () {
  // Thumbnail slider
  var thumbnailSlider = new Splide("#thumbnail_slider", {
    type: "loop",
    perPage: 3,
    focus: "center",
    gap: 0,
    pagination: false,
    arrows: true,
    cover: false,
    isNavigation: true,
    fixedWidth: 116,
    fixedHeight: 116,
    speed: 800,
    trimSpace: false,
    updateOnMove: true,
    start: 1, 
  });

  // Primary slider
  var primarySlider = new Splide("#primary_slider", {
    type: "fade",
    rewind: true,
    pagination: false,
    arrows: false,
    speed: 800,
    drag: false,
    start: 1, 
  });


  primarySlider.sync(thumbnailSlider);


  thumbnailSlider.mount();
  primarySlider.mount();


  setTimeout(function () {
    thumbnailSlider.go(1);
    primarySlider.go(1);
  }, 100);
});
// Test Parameters Tab functionality
// document.querySelectorAll('[data-box-id]').forEach((tabBtn) => {
//   tabBtn.addEventListener('click', function () {
//     const currentId = this.getAttribute('data-box-id');

//     // Hide all boxes
//     document.querySelectorAll('.openPop').forEach((box) => {
//       box.style.display = 'none';
//     });

//     // Show matched box
//     const activeBox = document.querySelector(
//       `.openPop[data-box-id="${currentId}"]`
//     );

//     if (activeBox) {
//       activeBox.style.display = 'block';
//     }
//   });
// });

document.querySelectorAll('.imgTxtBox .boxes').forEach((box) => {
  box.addEventListener('click', function () {
    const thisVal = this.getAttribute('data-box-id');

   
    this.parentElement.querySelectorAll('.boxes').forEach((sibling) => {
      sibling.classList.remove('actv');
    });
    this.classList.add('actv');

    
    const index5Wrap = this.closest('.index5Wrap');
    if (!index5Wrap) return;

    
    const allImages = index5Wrap.querySelectorAll('.rht .allImgs');

    allImages.forEach((img) => {
      const thatVal = img.getAttribute('data-box-id');

      if (thisVal === thatVal) {
        img.style.display = 'block';
      } else {
        img.style.display = 'none';
      }
    });
  });
});
 

// Test Parameters Tab functionality END


document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".section-header");
  const body = document.body;

  if (!header) return;

  // Get header height and set CSS variable
  const headerHT = header.offsetHeight;
  const headerHeight = `${headerHT}px`;

  header.style.setProperty("--hdrHeight", headerHeight);
  body.style.setProperty("--hdrHeight", headerHeight);

  // Add/remove sticky class on scroll
  window.addEventListener("scroll", function () {
    const scrollPos = window.scrollY;

    if (scrollPos > 0) {
      header.classList.add("sticky_header");
    } else {
      header.classList.remove("sticky_header");
    }
  });
});